import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/canto-cards/canto-cards/layouts/default.vue").then(m => m.default || m))
}